<div class="match-info">
  <div class="team-names">
    <div class="home-team">
      {{ event.homeTeam }} <ng-container *ngIf="event.awayTeam">- {{ event.awayTeam }}</ng-container>
    </div>
  </div>
</div>
